import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";

export const fetchAgents = createAsyncThunk(
  "agent/fetchAgents",
  async (arg) => {
    return httpRequest(`${BASE_URL}/Agents?SearchText=${arg.searchText}&PageSize=${arg.pageSize}&PageNumber=${arg.pageNumber}`);
  }
)

const agent = createSlice({
  name: 'agent',
  initialState: {
    agents: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAgents.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAgents.fulfilled, (state, action) => {
        state.loading = false;
        state.agents = action.payload;
      })
      .addCase(fetchAgents.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default agent.reducer;

